import * as React from 'react';
import { Container, Typography } from '@mui/material';
import { auth } from 'firebaseui';
import { PhoneAuthProvider } from 'firebase/auth';
import { ui } from '../../firebase';
import 'firebaseui/dist/firebaseui.css';
import './login.css';

export default function Login() {
  React.useEffect(() => {
    const uiConfig: auth.Config = {
      /*
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          return true;
        },
        uiShown: function () {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById('loader').style.display = 'none';
        },
      },
      */
      callbacks: {
        // handled in DashboardLayout
        signInSuccessWithAuthResult: () => false,
      },
      signInOptions: [PhoneAuthProvider.PROVIDER_ID],
      // Terms of service url.
      tosUrl: 'https://www.getporter.io/enterprise-terms-of-use',
      // Privacy policy url.
      privacyPolicyUrl: 'https://www.getporter.io/enterprise-privacy-policy',
    };

    let cancelled = false;
    const startUi = () => {
      if (!cancelled) ui.start('#firebaseui-auth-container', uiConfig);
    };

    // firebaseui's own deferral to window load can't be cancelled on unmount
    if (document.readyState === 'complete') startUi();
    else window.addEventListener('load', startUi);

    return () => {
      cancelled = true;
      window.removeEventListener('load', startUi);
      ui.reset();
    };
  }, []);

  return (
    <Container maxWidth="md" className="login-container">
      <div className="login-box">
        <img src="/Logo.svg" alt="Porter logo" />
        <Typography variant="h1">Log In</Typography>
        <div id="firebaseui-auth-container" />
      </div>
    </Container>
  );
}
